export default __webpack_public_path__ + "static/media/bigWinStars@3x.acfa89a1.png";